// import React, { useState, useRef, useEffect } from "react";
// import "./SlideOutMessageBox.css";

// const SlideOutMessageBox = ({
//   onCommentChange,
//   reviewHistory = [], // Receive review history as prop instead of fetching
//   activeSubjectId,
// }) => {
//   const [isOpen, setIsOpen] = useState(false);
//   const buttonRef = useRef(null);
//   const [comment, setComment] = useState("");
//   const [filteredReviewHistory, setFilteredReviewHistory] = useState([]);

//   // Filter review history based on active subject
//   useEffect(() => {
//     if (reviewHistory && reviewHistory.length > 0 && activeSubjectId) {
//       const subjectComments = reviewHistory.filter(
//         (review) => review.subject_id === activeSubjectId
//       );
//       setFilteredReviewHistory(subjectComments);
//     } else {
//       setFilteredReviewHistory(reviewHistory || []);
//     }
//   }, [reviewHistory, activeSubjectId]);

//   useEffect(() => {
//     const handleResize = () => {
//       if (buttonRef.current) {
//         buttonRef.current.style.transform = buttonRef.current.style.transform;
//       }
//     };

//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   const handleCommentChange = (e) => {
//     const newComment = e.target.value;
//     setComment(newComment);
//     onCommentChange?.(newComment);
//   };

//   // Parse comments to separate main comment from question-specific comments
//   const parseComments = (commentString) => {
//     if (!commentString) return { mainComment: "", questionComments: [] };

//     const parts = commentString.split(" *H* ");
//     const mainComment = parts[0].trim();
//     const questionComments = [];

//     for (let i = 1; i < parts.length; i++) {
//       const part = parts[i].trim();
//       if (part) {
//         const match = part.match(/^Question Id (\d+): (.+)$/);
//         if (match) {
//           questionComments.push({
//             questionId: match[1],
//             comment: match[2],
//           });
//         } else {
//           questionComments.push({
//             questionId: null,
//             comment: part,
//           });
//         }
//       }
//     }

//     return { mainComment, questionComments };
//   };

//   return (
//     <>
//       <div
//         ref={buttonRef}
//         className={`toggle-button-som ${isOpen ? "tab-knob" : ""}`}
//         onClick={() => setIsOpen(!isOpen)}
//         title={isOpen ? "Hide Review Comments" : "Show Review Comments"}
//         style={{
//           "--button-top": isOpen ? "40.9vh" : "50vh",
//           "--button-right": isOpen ? "50em" : "-6em",
//           "--button-margin-right": isOpen ? "-3.75em" : "0",
//         }}
//       >
//         REVIEW COMMENTS
//       </div>

//       <div className={`message-box-som${isOpen ? " open" : ""}`}>
//         <div className="message-content-som">
//           <textarea
//             style={{
//               height: "240px",
//               width: "100%",
//               padding: "10px",
//               fontSize: "14px",
//             }}
//             type="text"
//             placeholder="Start typing your review here..."
//             className="review-input-som"
//             value={comment}
//             onChange={handleCommentChange}
//           />

//           {/* Review History Section */}
//           <div
//             style={{ marginTop: "10px", maxHeight: "200px", overflowY: "auto" }}
//           >
//             {filteredReviewHistory.length === 0 && (
//               <div
//                 style={{
//                   textAlign: "center",
//                   padding: "10px",
//                   // color: "#666",
//                   fontSize: "14px",
//                 }}
//               >
//                 No review history found for this subject.
//               </div>
//             )}

//             {filteredReviewHistory.length > 0 &&
//               filteredReviewHistory
//                 .sort(
//                   (a, b) => new Date(b.reviewed_on) - new Date(a.reviewed_on)
//                 )
//                 .map((review, index) => {
//                   const { mainComment, questionComments } = parseComments(
//                     review.comments
//                   );

//                   return (
//                     <div key={index} style={{ marginBottom: "15px" }}>
//                       <div className="review-date-som">
//                         {review.reviewed_on}:{/* {review.reviewer_name} */}
//                       </div>

//                       {/* Main Comment */}
//                       {mainComment && (
//                         <div className="review-entry-som">
//                           <span>{mainComment}</span>
//                         </div>
//                       )}

//                       {/* Question-specific Comments */}
//                       {questionComments.map((qComment, qIndex) => (
//                         <div key={qIndex} className="review-entry-som">
//                           <span>
//                             {qComment.questionId
//                               ? `Question Id ${qComment.questionId}: ${qComment.comment}`
//                               : qComment.comment}
//                           </span>
//                           {/* <span style={{opacity:"0.5"}}>- {review.reviewer_name}</span> */}
//                         </div>
//                       ))}

//                     </div>
//                   );
//                 })}
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default SlideOutMessageBox;

import React, { useState, useRef, useEffect } from "react";
import "./SlideOutMessageBox.css";

const SlideOutMessageBox = ({
  onCommentChange,
  reviewHistory = [], // Receive review history as prop instead of fetching
  activeSubjectId,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const buttonRef = useRef(null);
  const [comment, setComment] = useState("");
  const [filteredReviewHistory, setFilteredReviewHistory] = useState([]);

  // Filter review history based on active subject
  useEffect(() => {
    if (reviewHistory && reviewHistory.length > 0 && activeSubjectId) {
      const subjectComments = reviewHistory.filter(
        (review) => review.subject_id === activeSubjectId
      );
      setFilteredReviewHistory(subjectComments);
    } else {
      setFilteredReviewHistory(reviewHistory || []);
    }
  }, [reviewHistory, activeSubjectId]);

  useEffect(() => {
    const handleResize = () => {
      if (buttonRef.current) {
        buttonRef.current.style.transform = buttonRef.current.style.transform;
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleCommentChange = (e) => {
    const newComment = e.target.value;
    setComment(newComment);
    onCommentChange?.(newComment);
  };

  // Parse comments to separate main comment from question-specific comments
  const parseComments = (commentString) => {
    if (!commentString) return { mainComment: "", questionComments: [] };

    const parts = commentString.split(" *H* ");
    const mainComment = parts[0].trim();
    const questionComments = [];

    for (let i = 1; i < parts.length; i++) {
      const part = parts[i].trim();
      if (part) {
        const match = part.match(/^Question Id (\d+): (.+)$/);
        if (match) {
          questionComments.push({
            questionId: match[1],
            comment: match[2],
          });
        } else {
          questionComments.push({
            questionId: null,
            comment: part,
          });
        }
      }
    }

    return { mainComment, questionComments };
  };

  return (
    <>
      {/* for opening the Main tab  */}
      <div
        className="toggle-button-som fixed-open-button"
        onClick={() => setIsOpen(true)}
        title="Show Review Comments"
        style={{
          position: "fixed",
          top: "500px",
          // left: "20px",
          zIndex: 90,
        }}
      >
        REVIEW COMMENTS
      </div>

      {/* button 2 inner  */}
      {/* {isOpen && (
        <div
          ref={buttonRef}
          className="toggle-button-som tab-knob"
          onClick={() => setIsOpen(false)}
          title="Hide Review Comments"
          style={{
            "--button-top": "40.9vh",
            "--button-right": "50em",
            "--button-margin-right": "-3.75em",
          }}
        >
          REVIEW COMMENTS
        </div>
      )} */}

      <div className={`message-box-som${isOpen ? " open" : ""}`}>
        {/* X Close Button */}
        {isOpen && (
          <button
            onClick={() => setIsOpen(false)}
            className="toggle-button-som-closed"
            style={{
              position: "absolute",
              top: "93.499px",
              left: "-140px",
            }}
            title="Close Review Comments"
          >
            REVIEW COMMENTS
          </button>
        )}
        <div className="message-content-som">
          <textarea
            style={{
              height: "240px",
              width: "100%",
              padding: "10px",
              fontSize: "14px",
            }}
            type="text"
            placeholder="Start typing your review here..."
            className="review-input-som"
            value={comment}
            onChange={handleCommentChange}
          />

          {/* Review History Section */}
          <div
            style={{ marginTop: "10px", maxHeight: "150px", overflowY: "auto" }}
          >
            {filteredReviewHistory.length === 0 && (
              <div
                style={{
                  textAlign: "center",
                  padding: "10px",
                  fontSize: "14px",
                }}
              >
                No review history found for this subject.
              </div>
            )}

            {filteredReviewHistory.length > 0 &&
              filteredReviewHistory
                .sort(
                  (a, b) => new Date(b.reviewed_on) - new Date(a.reviewed_on)
                )
                .map((review, index) => {
                  const { mainComment, questionComments } = parseComments(
                    review.comments
                  );

                  return (
                    <div key={index} style={{ marginBottom: "15px" }}>
                      <div className="review-date-som">
                        {review.reviewed_on}:
                      </div>

                      {/* Main Comment */}
                      {mainComment && (
                        <div className="review-entry-som">
                          <span>{mainComment}</span>
                        </div>
                      )}

                      {/* Question-specific Comments */}
                      {questionComments.map((qComment, qIndex) => (
                        <div key={qIndex} className="review-entry-som-History">
                          <span>
                            {qComment.questionId
                              ? `Question Id ${qComment.questionId}: ${qComment.comment}`
                              : qComment.comment}
                          </span>
                        </div>
                      ))}
                    </div>
                  );
                })}
          </div>
        </div>
      </div>
    </>
  );
};

export default SlideOutMessageBox;
